module.exports = __webpack_public_path__ + "img/fi-rr-cross-small.ba00f6a3.svg";